import React from 'react';

import Link from '@buyside/components/presentation/Link/link';
import SystemChatMessage from '@buyside/components/presentation/ChatLayout/Chat/ChatMessages/systemChatMessage';

import { accessIdeasUrl } from '@buyside/util/urlHelper';

const SystemChatMessages: React.FC<{
  canManageMessages: boolean;
  canViewIdeas: boolean;
  chatMessagesCount: number;
}> = ({ canManageMessages, canViewIdeas, chatMessagesCount }) => {
  if (chatMessagesCount && canViewIdeas) return null;

  const hasSingleMessage = chatMessagesCount === 1;

  if (chatMessagesCount && !canViewIdeas) {
    return (
      <SystemChatMessage>
        <p>
          There ha{hasSingleMessage ? 's' : 've'} been {chatMessagesCount} message
          {hasSingleMessage ? '' : 's'} from {hasSingleMessage ? 'a' : ''} community member
          {hasSingleMessage ? '' : 's'}. <Link to={accessIdeasUrl()}>Upgrade your account</Link>{' '}
          {canManageMessages ? 'to join' : 'to view'} the conversation!
        </p>
      </SystemChatMessage>
    );
  }

  return (
    <SystemChatMessage>
      <p>
        There are no messages yet.{' '}
        {canManageMessages ? (
          canViewIdeas ? (
            'Be the first to start the conversation!'
          ) : (
            <>
              <Link to={accessIdeasUrl()}>Upgrade your account</Link> to start the conversation!
            </>
          )
        ) : null}
      </p>
    </SystemChatMessage>
  );
};

export default SystemChatMessages;
